<div mat-dialog-title fxLayout="row" fxLayoutGap="3vw" *ngIf="data" class="collectionTitle">
    <div fxLayout="row" fxLayoutGap="1vh" fxLayoutAlign="center center">
        <div fxFlex>
            <span fxFlex="50">{{ data.name }}</span>
            <span class="case-title" *ngIf="data.caseId">
                {{'Case ID' | translate}}: {{data.caseId}}
            </span>
        </div>
        <div fxFlex align="right" *ngIf="['image'].includes(data.type) || (data.type == 'file' && extension == '.pdf')">
            <mat-icon (click)="openNewTab(data)" [matTooltip]="'Open in new tab' | translate">library_add</mat-icon>
        </div>
    </div>

</div>

<div mat-dialog-content>
    <div class="details">
        {{data.createdAt | date: 'yyyy/MM/dd HH:mm'}}<br>
        {{data.createdName}}
    </div>
    <div *ngIf="data.type == 'image'" style="text-align: center;width: 50vw;
    height: 50vh;">
        <!-- <img [src]="data.url" class="image" /> -->
        <app-custom-image-new [url]="data.url"></app-custom-image-new>
    </div>
    <div *ngIf="data.type == 'video'" class="video">
        <video width="640" height="360" controls *ngIf="extension !== '.wmv'">
            <source [src]="data.url" type="video/mp4">
            <source [src]="data.url" type="video/webm">
            <source [src]="data.url" type="video/ogg">
        </video>
        <div *ngIf="extension == '.wmv'" style="text-align: center;">
            <a [href]="data.url" target="_blank"><mat-icon class="default-icon"
                    [matTooltip]="'Click to download' | translate">video_file</mat-icon></a>
        </div>
    </div>
    <div *ngIf="data.type == 'audio'" class="audio">
        <audio controls>
            <source [src]="data.url" type="audio/mpeg">
            <source [src]="data.url" type="audio/ogg">
            <source [src]="data.url" type="audio/wav">
        </audio>
    </div>
    <div *ngIf="data.type == 'file'" class="file">
        <div style="width: 70vw; height: 60vh;" *ngIf="extension == '.pdf'">
            <pdf-viewer [src]="data.url" [render-text]="true" [original-size]="true" style="height: 100%"></pdf-viewer>
        </div>
        <div *ngIf="extension != '.pdf'" style="text-align: center;">
            <a [href]="data.url" target="_blank"><mat-icon class="default-icon"
                    [matTooltip]="'Click to download' | translate">description</mat-icon></a>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <div fxFlex align="right">
            <button class="red-text" mat-raised-button mat-dialog-close>
                {{ "Close" | translate }}
            </button>
        </div>
    </div>
</div>